<template>
  <el-dialog
    top="80px"
    title="Sắp xếp theo thứ tự"
    class="sort-files-popup"
    width="740px"
    append-to-body
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <grid
      v-show="!setting"
      ref="grid_file_sort"
      :draggable="true"
      :center="true"
      :sortable="true"
      :cell-width="cellWidth"
      :cell-height="cellHeight"
      :items="files"
      @sort="handleSort"
    >
      <template
slot="cell"
slot-scope="props">
        <SortItem
          :url="props.item.url"
          :index="props.index"
          :with-button="true"
          :type="type"
        />
      </template>
    </grid>
    <el-row
      slot="footer"
      class="footer"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
type="info"
:disabled="callingAPI"
@click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
type="primary"
:loading="callingAPI"
@click="handleSave"
        >Lưu</el-button
      >
    </el-row>
  </el-dialog>
</template>

<script>
import SortItem from "../items/SortItem.vue";

export default {
  name: "SortFilesPopup",
  components: {
    SortItem,
  },
  props: {
    visible: Boolean,
    files: Array,
    type: String,
  },
  data() {
    return {
      newFiles: [],
      cellWidth: 100,
      cellHeight: 80,
      wrapWidth: 700,
      setting: true,
      callingAPI: false,
    };
  },
  watch: {
    visible: "setWidth",
  },
  beforeMount() {},
  methods: {
    handleSave() {
      this.$emit("sorted", this.newFiles);
      this.$emit("close");
    },
    handleSort(e) {
      const items = e.items.map((_item) => {
        return _item.item;
      });
      this.newFiles = items;
    },
    setWidth() {
      if (this.visible) {
        this.setting = true;
        setTimeout(() => {
          this.getSize();
          this.$nextTick(() => {
            this.setting = false;
            window.addEventListener("resize", () => {
              this.getSize();
            });
          });
        }, 100);
      }
    },
    getSize() {
      const width = window.innerWidth;
      if (width <= 768) {
        this.cellWidth = 100;
        this.cellHeight = 80;
        this.wrapWidth = width - 75;
      } else {
        this.cellWidth = 140;
        this.cellHeight = 100;
        this.wrapWidth = 700;
      }
      if (this.$refs.grid_file_sort) {
        this.$refs.grid_file_sort.windowWidth = this.wrapWidth;
      }
    },
  },
};
</script>
<style lang="scss">
.sort-files-popup {
  .el-card__body {
    padding: 10px;
  }
}
</style>
